
      var _path, _rect, _circle, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSuspend = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h44v44H0z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 39.75,
  width: 35.75,
  height: 22,
  rx: 2.75,
  transform: "rotate(-90 11 39.75)",
  stroke: "#000",
  strokeWidth: 2.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 33.563,
  r: 2.063,
  transform: "rotate(-180 22 33.563)",
  fill: "#000"
})), /*#__PURE__*/React.createElement("mask", {
  id: "suspend_25206a3306b59f7a__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 10,
  y: 6,
  width: 24,
  height: 25
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M10 6.875h24v24H10z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#suspend_25206a3306b59f7a__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 23.875v-10a.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287.97.97 0 0 1 .713.287.97.97 0 0 1 .287.713v10c0 .283-.096.52-.287.712a.968.968 0 0 1-.713.288.968.968 0 0 1-.713-.288.967.967 0 0 1-.287-.712Zm5.525.1c-.333.2-.671.2-1.013 0-.341-.2-.512-.492-.512-.875v-8.45c0-.383.17-.675.512-.875.342-.2.68-.2 1.013 0L28 18.025c.333.2.5.483.5.85s-.167.65-.5.85l-6.475 4.25ZM22 21.35l4.125-2.475L22 16.4v4.95Z",
  fill: "var(--theme-primary, #810ea9)"
}))));

      const __svgRaw = "<svg width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<rect width=\"44\" height=\"44\" fill=\"white\"/>\r\n<rect x=\"11\" y=\"39.75\" width=\"35.75\" height=\"22\" rx=\"2.75\" transform=\"rotate(-90 11 39.75)\" stroke=\"black\" stroke-width=\"2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<circle cx=\"22\" cy=\"33.5625\" r=\"2.0625\" transform=\"rotate(-180 22 33.5625)\" fill=\"black\"/>\r\n<mask id=\"mask0_76_18790\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"10\" y=\"6\" width=\"24\" height=\"25\">\r\n<rect x=\"10\" y=\"6.875\" width=\"24\" height=\"24\" fill=\"#D9D9D9\"/>\r\n</mask>\r\n<g mask=\"url(#mask0_76_18790)\">\r\n<path d=\"M16 23.875V13.875C16 13.5917 16.0957 13.354 16.287 13.162C16.479 12.9707 16.7167 12.875 17 12.875C17.2833 12.875 17.521 12.9707 17.713 13.162C17.9043 13.354 18 13.5917 18 13.875V23.875C18 24.1583 17.9043 24.3957 17.713 24.587C17.521 24.779 17.2833 24.875 17 24.875C16.7167 24.875 16.479 24.779 16.287 24.587C16.0957 24.3957 16 24.1583 16 23.875ZM21.525 23.975C21.1917 24.175 20.854 24.175 20.512 23.975C20.1707 23.775 20 23.4833 20 23.1V14.65C20 14.2667 20.1707 13.975 20.512 13.775C20.854 13.575 21.1917 13.575 21.525 13.775L28 18.025C28.3333 18.225 28.5 18.5083 28.5 18.875C28.5 19.2417 28.3333 19.525 28 19.725L21.525 23.975ZM22 21.35L26.125 18.875L22 16.4V21.35Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/suspend.25206a3306b59f7a5d807974730d0bf2.svg"),
        {
          React: SvgSuspend,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      